import { TypedUseQueryHookResult, TypedUseQueryStateResult } from "@reduxjs/toolkit/query/react";
import { JsonView, defaultStyles } from "react-json-view-lite";
import { timeAgo } from "../app/datetimeUtils";

import "react-json-view-lite/dist/index.css";

interface Props {
	className?: string;
	heading: string;
	result: TypedUseQueryHookResult<any, any, any> | TypedUseQueryStateResult<any, any, any>;
}

export default function RtkqResultViewer(props: Props) {
	return (
		<div className={`mt-4 ${props.className}`}>
			<h3>{props.heading}</h3>
			{props.result.status && <p className="mt-2">{`Status: ${props.result.status}`}</p>}
			{props.result.endpointName && (
				<p className="text-sm">{`Endpoint: ${props.result.endpointName}`}</p>
			)}
			{props.result.isUninitialized && <p>Uninitialized...</p>}
			{props.result.isFetching && <p>Fetching...</p>}
			{props.result.isLoading && <p>Loading...</p>}
			{props.result.isSuccess &&
				props.result.fulfilledTimeStamp &&
				props.result.startedTimeStamp && (
					<p className="text-sm">
						Loaded {timeAgo(props.result.fulfilledTimeStamp).toLowerCase()} (
						{props.result.fulfilledTimeStamp - props.result.startedTimeStamp} ms).
					</p>
				)}
			{props.result.data != null && (
				<div className="font-mono mt-2">
					<JsonView data={props.result.data} style={defaultStyles} />
				</div>
			)}

			{props.result.isError && <p>Error fetching...</p>}
			{props.result.error != null && (
				<div className="font-mono mt-2">
					<JsonView data={props.result.error} style={defaultStyles} />
				</div>
			)}
		</div>
	);
}
